import { useQuery } from '@tanstack/react-query';
import { SettingsApi } from '@/features/settings/api';

export const useGetInvestorVerificationSettings = () => {
  const { isLoading, isError, data, error, refetch } = useQuery({
    queryKey: ['settingsApi.getInvestorVerificationSettings'],
    queryFn: SettingsApi.getInvestorVerificationSettings,
    select: (res) => res.data
  });

  return {
    isLoading,
    isError,
    data,
    error,
    refetch
  };
};
